import { InputNumber } from "primereact/inputnumber";

// employee working hour model grid template
export const EmployeeWageGrid = ({ hours, onChange, timePeriod, selectedEmployee, showHoliday }: any) => {
  const disabled = timePeriod?.payment_status === true;

  return (
    <div className="grid">
      {/* Stat Holiday */}
      {showHoliday && (
        <div className="field col-12 md:col-3">
          <label>Stat Holiday</label>
          <InputNumber
            value={hours?.holiday_hour}
            onValueChange={(e) => onChange(e, "holiday_hour")}
            disabled={selectedEmployee?.pay_stat_holiday === false || disabled}
            mode="decimal"
            maxFractionDigits={2}
            className="w-full"
          />
        </div>
      )}
    </div>
  );
};

// add working hour addition common field for both wage 1 and wage 2

export const EmployeeAdditionalPayGrid = ({ hours, onChange, selectedEmployee, timePeriod }: any) => {
  if (!hours) return null;

  const isPaymentDisabled = timePeriod?.payment_status === true;

  return (
    <div className="grid mt-0">
      {timePeriod.holiday_status === 1 && (
        <div className="field col-12 md:col-3">
          <label>{hours?.night_wage ? "Stat Holiday (Wage 1)" : "Stat Holiday"}</label>
          <InputNumber
            value={hours?.holiday_hour}
            onValueChange={(e) => onChange(e, "holiday_hour")}
            // disabled={selectedEmployee?.pay_stat_holiday === false || timePeriod?.payment_status === true}
            disabled={isPaymentDisabled}
            mode="decimal"
            maxFractionDigits={2}
            className="w-full"
          />
        </div>
      )}

      {timePeriod.holiday_status === 1 && hours?.night_wage != 0 && hours?.night_wage != "0.00" && (
        <div className="field col-12 md:col-3">
          <label htmlFor="wage">Stat Holiday (wage 2) </label>
          <form autoComplete="off">
            <div className="flex-1 input-effect-div p-inputgroup">
              <InputNumber
                value={hours?.holiday_night_hour}
                onValueChange={(e) => onChange(e, "holiday_night_hour")}
                // disabled={selectedEmployee?.pay_stat_holiday === false || timePeriod?.payment_status === true}
                disabled={isPaymentDisabled}
                mode="decimal"
                maxFractionDigits={2}
                className="w-full"
              />
            </div>
          </form>
        </div>
      )}

      {/* Vacation Payout */}
      <div className="field col-12 md:col-3">
        <label>Vacation Payout</label>
        <div className="flex-1 input-effect-div p-inputgroup">
          <span className="font-bold p-inputgroup-addon">$</span>
          <InputNumber
            value={hours?.vacation_payout}
            onValueChange={(e) => onChange(e, "vacation_payout")}
            disabled={selectedEmployee?.vacation_hold === false || selectedEmployee?.no_vacation_payout === true || isPaymentDisabled}
            mode="decimal"
            maxFractionDigits={2}
            className="w-full"
          />
          <span className="font-bold p-inputgroup-addon">CAD</span>
        </div>
      </div>

      {/* Bonus */}
      <div className="field col-12 md:col-3">
        <label>Bonus</label>
        <div className="flex-1 input-effect-div p-inputgroup">
          <span className="font-bold p-inputgroup-addon">$</span>
          <InputNumber
            value={hours.bonus}
            onValueChange={(e) => onChange(e, "bonus")}
            disabled={isPaymentDisabled}
            mode="decimal"
            maxFractionDigits={2}
            className="w-full"
          />
          <span className="font-bold p-inputgroup-addon">CAD</span>
        </div>
      </div>

      {/* Commission */}
      <div className="field col-12 md:col-3">
        <label>Commission</label>
        <div className="flex-1 input-effect-div p-inputgroup">
          <span className="font-bold p-inputgroup-addon">$</span>
          <InputNumber
            value={hours.commission}
            onValueChange={(e) => onChange(e, "commission")}
            disabled={isPaymentDisabled}
            mode="decimal"
            maxFractionDigits={2}
            className="w-full"
          />
          <span className="font-bold p-inputgroup-addon">CAD</span>
        </div>
      </div>

      {/* Health Benefit */}
      <div className="field col-12 md:col-3">
        <label>Health Benefit</label>
        <div className="flex-1 input-effect-div p-inputgroup">
          <span className="font-bold p-inputgroup-addon">$</span>
          <InputNumber
            value={hours.medical_exemption}
            onValueChange={(e) => onChange(e, "medical_exemption")}
            disabled={isPaymentDisabled}
            mode="decimal"
            maxFractionDigits={2}
            className="w-full"
          />
          <span className="font-bold p-inputgroup-addon">CAD</span>
        </div>
      </div>

      {/* Tips */}
      <div className="field col-12 md:col-3">
        <label>Tips</label>
        <div className="flex-1 input-effect-div p-inputgroup">
          <span className="font-bold p-inputgroup-addon">$</span>
          <InputNumber
            value={hours.tip}
            onValueChange={(e) => onChange(e, "tip")}
            disabled={isPaymentDisabled}
            mode="decimal"
            maxFractionDigits={2}
            className="w-full"
          />
          <span className="font-bold p-inputgroup-addon">CAD</span>
        </div>
      </div>
    </div>
  );
};
